import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["iframe"]
  static values = {
    dismissUrl: String,
    remindUrl: String,
    pendingCourseModalId: String
  }

  connect() {
    this.bindDismissOnClose()
  }

  disconnect() {
    if (!this.boundDismissOnClosed) return

    this.element.removeEventListener("railsui-modal:closed", this.boundDismissOnClosed)
    this.boundDismissOnClosed = null
  }

  remindLater() {
    if (this.remindPosted) return
    if (!this.remindUrlValue) return

    const token = document.querySelector("meta[name='csrf-token']")?.content
    if (!token) return

    this.remindPosted = true
    this.skipPermanentDismiss = true

    fetch(this.remindUrlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": token,
        Accept: "application/json"
      },
      credentials: "same-origin",
      keepalive: true
    })
      .then((response) => {
        if (!response.ok) {
          this.remindPosted = false
          this.skipPermanentDismiss = false
          return
        }

        this.closeModal()
      })
      .catch(() => {
        this.remindPosted = false
        this.skipPermanentDismiss = false
      })
  }

  dismissPermanent() {
    if (this.skipPermanentDismiss) return
    if (this.dismissPosted) return
    if (!this.dismissUrlValue) return

    const token = document.querySelector("meta[name='csrf-token']")?.content
    if (!token) return

    this.dismissPosted = true

    fetch(this.dismissUrlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": token,
        Accept: "application/json"
      },
      credentials: "same-origin",
      keepalive: true
    })
      .then((response) => {
        if (!response.ok) this.dismissPosted = false
      })
      .catch(() => {
        this.dismissPosted = false
      })
  }

  // Contract: railsui-modal dispatches "railsui-modal:closed" from close() so
  // X, Esc, and overlay permanently dismiss unless Remind Me Later ran.
  bindDismissOnClose() {
    if (this.boundDismissOnClosed) return

    this.boundDismissOnClosed = () => {
      this.stopVideo()
      this.dismissPermanent()
      this.openPendingCourseModal()
    }
    this.element.addEventListener("railsui-modal:closed", this.boundDismissOnClosed)
  }

  stopVideo() {
    if (!this.hasIframeTarget) return

    this.iframeTarget.removeAttribute("src")
  }

  openPendingCourseModal() {
    if (!this.hasPendingCourseModalIdValue) return

    const pendingModal = document.getElementById(this.pendingCourseModalIdValue)
    if (!pendingModal) return

    const modal = this.application.getControllerForElementAndIdentifier(
      pendingModal,
      "railsui-modal"
    )
    modal?.show()
  }

  closeModal() {
    const modal = this.application.getControllerForElementAndIdentifier(
      this.element,
      "railsui-modal"
    )
    if (modal) {
      modal.close()
      return
    }

    this.element.dispatchEvent(new CustomEvent("railsui-modal:closed", { bubbles: true }))
  }
}
